import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { SidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

const getDocumentsFolderPath = (state: unknown): string[] | null => {
  if (!state || typeof state !== 'object') {
    return null;
  }

  const path = (state as { documentsFolderPath?: unknown }).documentsFolderPath;

  if (!Array.isArray(path)) {
    return null;
  }

  const isValidPath = path.every((item) => typeof item === 'string' || typeof item === 'number');

  if (!isValidPath) {
    return null;
  }

  return path.map((item) => String(item));
};

export const useAutoOpenDocumentsFolder = (store: SidebarDocumentsStore, organizationId?: number): void => {
  const navigate = useNavigate();
  const location = useLocation();

  const documentsFolderPath = React.useMemo(() => getDocumentsFolderPath(location.state), [location.state]);

  React.useEffect(() => {
    if (
      !documentsFolderPath ||
      !organizationId ||
      store.organizationId !== organizationId ||
      !store.treeStore.meta.isLoaded
    ) {
      return;
    }

    void store.openFolderPath(documentsFolderPath);

    if (location.state && typeof location.state === 'object' && location.state !== null) {
      const nextState = { ...(location.state as Record<string, unknown>) };

      delete nextState.documentsFolderPath;

      const stateToSet = Object.keys(nextState).length > 0 ? nextState : null;

      navigate(
        {
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
        },
        { replace: true, state: stateToSet },
      );
    }
  }, [
    documentsFolderPath,
    store,
    store.treeStore.meta.isLoaded,
    store.organizationId,
    navigate,
    location.pathname,
    location.search,
    location.hash,
    location.state,
    organizationId,
  ]);
};
